function d(i, s, a) {
  i != 0 ? s.classList.add(a) : s.classList.remove(a);
}
export {
  d as a
};
